module.exports = __webpack_public_path__ + "img/edit-btn.6ca0d349.svg";